import React, { Component } from 'react'

import './Footer.css';

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      appVersion: 'Unknown',
      apiVersion: 'Unknown',
    }
  }

  componentDidMount() {
    this.fetchAppVersion();
    this.fetchApiVersion();
  }

  fetchAppVersion() {
    this.setState({ appVersion: process.env.REACT_APP_VERSION_INFO })
  }

  fetchApiVersion() {
    let versionInfo = ''
    let url = process.env.REACT_APP_DS_API_URL + "/version"
    fetch(url).then(response => {
        return response.json();
    }).then(data => {
        versionInfo = data;
        if (versionInfo && versionInfo.version) {
          this.setState({ apiVersion: versionInfo.version });
        }
    });
}

  render() {
    return(
      <footer className="footer">
          <div className="footer-container">
              <div>
              <span className="text-muted">&copy;2021-2024 CNM - Digital Services</span>
              </div>
              <div>
                <span className="text-muted">App v{this.state.appVersion}</span>
                &nbsp;&nbsp;
                -
                &nbsp;&nbsp;
                <span className="text-muted">API v{this.state.apiVersion}</span>
              </div>
          </div>
      </footer>
    );
  }
}

export default Footer;
